import { GoodsEcCategoryCodeComboBoxModel } from '../goods-ec-category-code-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品ECカテゴリ情報リストを取得する
 *
 * @export API通信成功時の処理
 * @class GetGoodsEcCategoryListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetGoodsEcCategoryListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: GoodsEcCategoryCodeComboBoxModel;
  private categoryDiv: string = null;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGoodsEcCategoryListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        CategoryDiv: this.categoryDiv,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {GoodsEcCategoryCodeComboBoxModel} model
   * @param {string} categoryDiv
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetGoodsEcCategoryListService
   */
  execute(model: GoodsEcCategoryCodeComboBoxModel, categoryDiv: string, successFunc: Function = null) {
    this.model = model;
    this.categoryDiv = categoryDiv;
    this.successFunc = successFunc;
    this.send('getEcCategory', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGoodsEcCategoryListService
   */
  success(data: any) {
    this.model.updateGoodsEcCategoryList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
